import { render } from "./NewsListing.vue?vue&type=template&id=774478d8&ts=true"
import script from "./NewsListing.vue?vue&type=script&lang=ts"
export * from "./NewsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__